import axios from "axios";
import { gatewayUrl } from "@Constants/gatewayUrl";
import { createConfig } from "@Utils/createConfig";
import { LEGACY_LANGUAGE_CODES } from "@juristic/types/generic/language";
export async function putLanguage(token, language) {
    const header = createConfig(token);
    const url = `${gatewayUrl}/language`;
    const body = {
        lng: language
    };
    const res = await axios.put(url, body, header);
    return LEGACY_LANGUAGE_CODES[res.data] ?? res.data;
}
